import type { IntervalType } from 'redux-store/slices/products/types';

export const plansDescription: Record<IntervalType, string> = {
  week: 'Pay once at week',
  month: 'Pay once at month',
  '3month': 'Billed every 3 months',
  '6month': 'Billed every 6 months',
  year: 'Billed once a year',
  '2-year': 'Billed every 2 years',
  lifetime: 'One-time payment, full access forever',
  'year-gift': 'Valid for one year',
  quarterly: 'Pay once at quarterly',
  'semi-annual': 'Pay once at semi-annual'
};

export const plansDescriptionRu: Record<IntervalType, string> = {
  week: 'Pay once at week',
  month: 'Pay once at month',
  '3month': 'Billed every 3 months',
  '6month': 'Billed every 6 months',
  year: 'Billed once a year centapp',
  '2-year': 'Billed every 2 years',
  lifetime: 'One-time payment, full access forever',
  'year-gift': 'Valid for one year',
  quarterly: 'Pay once at quarterly',
  'semi-annual': 'Pay once at semi-annual'
};
